import { useTranslation } from '@mukil/i18n';
import type { DatePickerLabels } from '@jumpstone/ui-react';

/**
 * Returns localized {@link DatePickerLabels} for the shared @jumpstone/ui-react
 * `DatePicker`. The component itself ships no English fallbacks (see #13648
 * in apps/ledger-web's `use_date_picker_labels.ts`, which this mirrors), so
 * every caller must pass the result of this hook to the `labels` prop --
 * otherwise the calendar chrome (Clear/Today/etc.) silently renders in
 * English inside an otherwise-localized si/ta screen.
 */
export function useDatePickerLabels(): DatePickerLabels {
  const { t } = useTranslation('wp');
  return {
    placeholder: t('date_picker.placeholder'),
    previous_month: t('date_picker.previous_month'),
    next_month: t('date_picker.next_month'),
    open_calendar: t('date_picker.open_calendar'),
    clear: t('date_picker.clear'),
    today: t('date_picker.today'),
  };
}
